import { ConnectedProps } from "react-redux";
import React from "react";

import AddEditForm from "../AddEditForm";
import connector from "./Container";

const AddUser = ({ state, actions }: ConnectedProps<typeof connector>) => {
  return <AddEditForm isAdd={true} state={state} actions={actions} />;
};

export default AddUser;
